import React from 'react';
import styles from './AdminMobileAllStoreSaleList.module.css';
import PropTypes from 'prop-types';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import { pageEH3FontSize } from '../constraints/AdminConst';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';

const AdminMobileAllStoreSaleList = ({saleData}) => {
    // saleData가 없거나 비어있을 때 예외 처리
    if (!saleData || saleData.length === 0) {
        return (
            <AdminMobileEmptyMsg />
        );
    }

    return (
        <VerticalFlex>
            {saleData && saleData.map((item, index) => (
                <FlexChild key={index}>
                    <div className={styles.list}>
                        <HorizontalFlex gap="0.5rem">
                            <FlexChild width="auto">
                                <img className={styles.productImg} src={item.productImg} alt={item.productName} />
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild alignItems="flex-start">
                                        <P size={pageEH3FontSize}>{item.productName}</P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <P size={pageEH3FontSize}>{item.price.toLocaleString()}</P>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild width="auto">
                                <P size={pageEH3FontSize} padding="0 1.5rem 0 0">{item.quantity}</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                </FlexChild>
            ))}
        </VerticalFlex>
    );
};

// Props의 유효성을 검사하는 코드
AdminMobileAllStoreSaleList.propTypes = {
    saleData: PropTypes.arrayOf(
        PropTypes.shape({
            createDateTime: PropTypes.string.isRequired,
            deliveryStatus: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
            price: PropTypes.number.isRequired,
            productImg: PropTypes.string.isRequired,
            productName: PropTypes.string.isRequired,
            purchaseOrderId: PropTypes.string,
            quantity: PropTypes.number.isRequired,
            supplyPrice: PropTypes.number,
        })
    ),
};

export default AdminMobileAllStoreSaleList;